module.exports = __webpack_public_path__ + "img/truck_home.3e03e691.png";